import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../Endpoints/Endpoints'

const UpdateChakraGame = ({ type }) => {
  const [formData, setFormData] = useState({
    theme: '',
    agentname: '',
    description: '',
    answer: '',
    number: '',
    value: '',
  });

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { spokeid,bladeid } = useParams();

  useEffect(() => {
    fetchData();
  }, [spokeid],[bladeid]);

  const fetchData = async () => {
    try {
      const apiUrl = type === 'spoke' ? API.GET_SPOKE_BYID(spokeid) : API.GET_BLADE_BYID(bladeid);
      const res = await axios.get(apiUrl);
      const data = Array.isArray(res.data) ? res.data[0] : res.data;

      setFormData({
        theme: data.theme || '',
        agentname: data.agentname || '',
        description: data.description || '',
        answer: data.answer || '',
        number: type === 'spoke' ? data.spokenumber : data.bladenumber,
        value: type === 'spoke' ? data.spoke : data.blade,
      });
    } catch (err) {
      setError('Error fetching data: ' + err.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const payload =
      type === 'spoke'
        ? {
            theme: formData.theme,
            agentname: formData.agentname,
            description: formData.description,
            answer: formData.answer,
            spokenumber: formData.number,
            spoke: formData.value,
          }
        : {
            theme: formData.theme,
            agentname: formData.agentname,
            description: formData.description,
            answer: formData.answer,
            bladenumber: formData.number,
            blade: formData.value,
          };

    try {
      const apiUrl = type === 'spoke' ? API.PUT_SPOKE_API(spokeid) : API.PUT_BLADE_API(bladeid);
      await axios.put(apiUrl, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      alert(`${type === 'spoke' ? 'Spoke' : 'Blade'} updated successfully`);
      navigate('/chakragametable'); // Change to the page you want to redirect after update
    } catch (err) {
      alert('Update failed: ' + err.message);
    }
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm(`Are you sure you want to delete this ${type}?`);
    if (!confirmDelete) return;
  
    try {
      const apiUrl = type === 'spoke' ? API.DELETE_SPOKE_API(spokeid) : API.DELETE_BLADE_API(bladeid);
      await axios.delete(apiUrl);
      alert(`${type === 'spoke' ? 'Spoke' : 'Blade'} deleted successfully`);
      navigate('/chakragameview'); // Redirect after delete
    } catch (err) {
      alert('Delete failed: ' + err.message);
    }
  };
  

  return (
    <div className="bg-[#B5B5B5] min-h-screen py-10">
      <div className="max-w-3xl mx-auto">
        <form
          onSubmit={handleUpdate}
          className="bg-white shadow-md rounded px-8 pt-6 pb-8"
        >
          <h2 className="text-xl font-semibold mb-4">
            Update {type === 'spoke' ? 'Spoke' : 'Blade'}
          </h2>

          {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

          {['theme', 'agentname', 'description', 'answer'].map((field) => (
            <div className="mb-4" key={field}>
              <label className="block text-gray-700 text-sm font-bold mb-2 capitalize">
                {field}
              </label>
              <input
                type="text"
                name={field}
                value={formData[field]}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
              />
            </div>
          ))}

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {type === 'spoke' ? 'Spoke Number' : 'Blade Number'}
            </label>
            <input
              type="text"
              name="number"
              value={formData.number}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              {type === 'spoke' ? 'Spoke' : 'Blade'}
            </label>
            <input
              type="text"
              name="value"
              value={formData.value}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700"
            />
          </div>

          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="bg-[#e64a32] text-white font-bold py-2 px-4 rounded"
            >
              Update
            </button>
            <button
              type="button"
              onClick={() => navigate('/chakragameview')}
              className="bg-gray-500 text-white font-bold py-2 px-4 rounded"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateChakraGame;
